import { z } from 'zod';
import { AuthError } from './auth-error';

const entraSchema = z.object({
  clientId: z.uuid(),
  tenantId: z.uuid(),
  // One delegated permission for one resource. Never substitute a Graph scope.
  apiScope: z.string().refine((value) => {
    try {
      const url = new URL(value);
      return (
        ['api:', 'https:'].includes(url.protocol) &&
        Boolean(url.host) &&
        url.pathname.length > 1 &&
        !url.username &&
        !url.password &&
        !url.search &&
        !url.hash &&
        !/\s/.test(value) &&
        url.hostname !== 'graph.microsoft.com'
      );
    } catch {
      return false;
    }
  })
});

export type AuthConfig =
  { mode: 'demo' } | ({ mode: 'entra' } & z.infer<typeof entraSchema>);

export const readAuthConfig = (env: Record<string, unknown>): AuthConfig => {
  if (env.VITE_AUTH_MODE === 'demo') return { mode: 'demo' };
  if (env.VITE_AUTH_MODE && env.VITE_AUTH_MODE !== 'entra') {
    throw new AuthError('Invalid authentication mode.', 'configuration_error');
  }
  const result = entraSchema.safeParse({
    clientId: env.VITE_ENTRA_CLIENT_ID,
    tenantId: env.VITE_ENTRA_TENANT_ID,
    apiScope: env.VITE_ENTRA_API_SCOPE
  });
  if (!result.success) {
    throw new AuthError('Microsoft sign-in is not configured.', 'configuration_error');
  }
  return { mode: 'entra', ...result.data };
};
